import { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import LoggedLayout from 'layouts/LoggedLayout';
import axios from 'axios';
import styled from 'styled-components';
import { hasCapability } from 'helpers/user';

const Filters = styled.div`
	display: flex;
	justify-content: end;

	.filters-inputs {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex-wrap: nowrap;

		@media (max-width: 1200px) {
			& {
				display: flex !important;
				justify-content: flex-end;
				width: 100% !important;
			}
		}

		@media (min-width: 576px) and (max-width: 1200px) {
			& > *:nth-child(2) {
				min-width: 200px;
			}
		}

		@media (min-width: 768px) and (max-width: 991px) {
			#search-box {
				flex: 1;
			}
		}

		@media (max-width: 576px) {
			flex-direction: column;
			align-items: stretch;
			gap: 1rem;
			width: 100%;
			max-width: 100%;
			box-sizing: border-box;

			& > * {
				width: 100%;
				max-width: 100%;
				min-width: 0;
				box-sizing: border-box;
			}

			#search-box {
				width: 100%;
				max-width: 100%;
				min-width: 0;
				box-sizing: border-box;
			}
		}

		@media (max-width: 374px) {
			& {
				margin: auto;
			}
		}
	}

	.filter-buttons{
		width: auto !important;

		& > * {
			@media (max-width: 576px) {
				width: 100%;
				text-align: center;
			}
		}

		@media (max-width: 1200px) {
			margin-right: 0.5rem;
		}

		@media (max-width: 991px) {
			width: calc(100% - 1.5rem) !important;
		}

		@media (max-width: 767px) {
			width: calc(100% - 2rem);
		}

		@media (max-width: 576px) {
			display: flex !important;
			flex-direction: column !important;
			flex-wrap: nowrap;
			align-items: stretch !important;
			width: 100% !important;
		}
	}
	
	@media (max-width: 1200px) {
		justify-content: center;
		flex-direction: column;
		align-items: flex-end;

		& > *,
		.empowered-selector {
			width: 100% !important;
			display: block !important;
		}

		& > * {
			margin-bottom: 10px;
		}
	}

	@media (max-width: 991px) {
		display: grid;
		grid-template-columns: 1fr;
		grid-auto-rows: auto;
		gap: 10px;
		align-items: stretch;

		& > * {
			width: 100% !important;
			margin-bottom: 0 !important;
		}
	}

	@media (max-width: 767px) {
		grid-template-columns: 1fr;
	}
`;

let axiosCancelToken = null;

export default function Zones() {
	let [zones, setZones] = useState([]);

	useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();

		const getZones = async () => {
			return axios.get('api/zones/list', {
				params: {},
				cancelToken: axiosCancelToken.token
			}).then((response) => {
		    	setZones(response.data);
		  	}).catch((error) => {
				if ( axios.isCancel(error) ) return;
			});
		}

		getZones();

		return function cleanup() {
           	axiosCancelToken.cancel();
        }
	}, []);

	return (
		<LoggedLayout>
			<div className="col-md-12 mb-3">
				<div className="bg-white p-2 rounded shadow-sm">
					<div className="row">
						<div className="col-lg-10 align-content-center">
							<h4 className="mb-0">Listado de zonas</h4>
							<small>Las zonas se utilizan para agrupar estaciones por zonas de distribución</small>
						</div>
						<Filters className="col-lg-2">
							<div className="d-flex flex-row flex-nowrap align-items-center gap-1 filter-buttons" style={{whiteSpace: 'nowrap', width: 'calc(100% - 2rem)'}}>
								{ hasCapability('probes', 'add') &&
									<NavLink to="/zones/add" className="btn btn-sm btn-plenoil-light btn-plenoil p-0 px-2 d-inline-flex align-items-center text-nowrap col-4 col-lg-auto">Añadir zona</NavLink>
								}
							</div>
						</Filters>
					</div>
				</div>
			</div>

			<div className="pt-2 col-md-12">
				<div className="px-0 col-lg pl-lg-0">
					<div className="row m-0 pb-2">
						<div className="col-12 px-0">
							<div className="h-100 p-4 background-color-blanco shadow rounded">
								<div className="table-responsive-rows">
									<div className="mvc-grid mvc-grid-header-mode">
										<div className="mvc-grid-table">
											<table>
												<thead>
													<tr className="bg-plenoil-primary text-plenoil-black">
														<th className="title_precios-nombre">Nombre</th>
														<th className="title_precios-estaciones">Estaciones</th>
														<th></th>
													</tr>
												</thead>
												<tbody>
													{ zones.map((el, idx) => {
														return (
															<tr key={idx}>
																<td className="title_precios-nombre">{el.name}</td>
																<td className="title_precios-estaciones">{ el.middlewareStations?.map((mEl, idx) => {
																	return <div key={idx}>{ mEl.name }</div>;
																}) }</td>
																<td>
																	<NavLink to={'/zones/edit/' + el.id} className="btn btn-sm btn-plenoil-outline-black d-flex flex-row flex-nowrap gap-2 align-items-center px-2 py-0" style={{width: '26px', height: '26px', minWidth: '0px', borderRadius: '1.5rem'}}><i className="bi bi-pencil"></i></NavLink>
																</td>
															</tr>
														)
													}) }
													{ !zones.length && <tr key="empty"><td colSpan="100%">No hay zonas</td></tr> }
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</LoggedLayout>
	);
}


